export default "__VITE_ASSET__9cbcd4e3__"